import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import "@/plugins/vee-validate";
import "@/assets/styles/theme.scss";
import { initTheme } from "@/utils/theme";
// import "ant-design-vue/dist/reset.css";
import "flatpickr/dist/flatpickr.min.css";
// import "node_modules/ant-design-vue/dist/reset.css";

import {
    Badge,
    Button,
    Card,
    Checkbox,
    Col,
    Collapse,
    DatePicker,
    Divider,
    Drawer,
    FloatButton,
    Form,
    Input,
    InputNumber,
    Layout,
    Modal,
    Pagination,
    Popconfirm,
    Radio,
    Result,
    Row,
    Select,
    Space,
    Spin,
    Switch,
    Table,
    Tag,
} from "ant-design-vue";

initTheme();

const pinia = createPinia();
createApp(App)
    .use(pinia)
    .use(router)
    .use(Layout)
    .use(Collapse)
    .use(Button)
    .use(Spin)
    .use(Result)
    .use(Card)
    .use(Divider)
    .use(Col)
    .use(Row)
    .use(Space)
    .use(Drawer)
    .use(Table)
    .use(Form)
    .use(InputNumber)
    .use(Tag)
    .use(Modal)
    .use(Input)
    .use(Select)
    .use(DatePicker)
    .use(Checkbox)
    .use(Pagination)
    .use(Radio)
    .use(Switch)
    .use(FloatButton)
    .use(Badge)
    .use(Popconfirm)
    .mount("#app");
